import i18n from "i18next"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"

import { ADMIN_LOCALES, DEFAULT_ADMIN_LOCALE } from "constants/locales"

const storedLang = localStorage.getItem("ga-admin-language")

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_ADMIN_LOCALE,
    lng: storedLang || DEFAULT_ADMIN_LOCALE,
    supportedLngs: ADMIN_LOCALES,
    react: {
      useSuspense: true
    },
    interpolation: {
      escapeValue: false
    },
    ns: ["translation"],
    defaultNS: "translation"
  })

// eslint-disable-next-line import/no-default-export
export default i18n
